import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '01',
  value: '9 CHF',
  title: 'SBB Junior-Karten & Familien-Guide 🎒',
  desc: 'Der komplette Leitfaden für Kinder-Gratis-Tickets und Familien-Pässe. Kinder unter 9 Jahren fahren in 10 Stationen gratis.'
}, {
  num: '02',
  value: '7 CHF',
  title: 'Der Wetter & Schnee-Insider-Guide ❄️',
  desc: 'Lesen Sie das Wetter wie ein Bergbauer. Wissen Sie immer, wo der beste Schnee ist — bevor alle anderen es wissen.'
}, {
  num: '03',
  value: '8 CHF',
  title: 'Resale-Strategie: Geld zurück am Saisonende 💰',
  desc: 'Verkaufen Sie Ihre Ausrüstung am Ende der Saison gewinnbringend. Das Ricardo.ch System für maximale Rückgewinnung.'
}];
export function BonusSection() {
  return <section className="py-10 sm:py-12 px-4 relative overflow-hidden" data-id="element-34">
      <div className="absolute inset-0 bg-brand-orange/5 blur-[120px] rounded-full max-w-3xl mx-auto" data-id="element-35" />

      <div className="max-w-xl mx-auto relative z-10" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 flex flex-col items-center" data-id="element-37">
          <div className="bg-brand-orange/20 p-3 rounded-full mb-3" data-id="element-38">
            <GiftIcon className="w-8 h-8 text-brand-orange" data-id="element-39" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-2" data-id="element-40">
            Exklusive Bonus-Geschenke
          </h2>
          <p className="text-sm text-brand-gold font-bold" data-id="element-41">
            3 Gratis-Boni in Ihrem Paket.
            <br data-id="element-42" />
            Gesamtwert der Boni: 49 CHF — Heute 0.00 CHF
          </p>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-43">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-gradient-to-br from-brand-card to-[#2a1810] border border-brand-orange/30 p-5 rounded-2xl" data-id="element-44">
              <div className="flex items-center gap-2 mb-2" data-id="element-45">
                <span className="text-brand-orange font-black text-xs tracking-widest" data-id="element-46">
                  BONUS {bonus.num}
                </span>
                <span className="text-gray-600" data-id="element-47">|</span>
                <span className="text-xs font-black text-brand-gold uppercase" data-id="element-48">
                  {bonus.value} — Heute gratis
                </span>
              </div>
              <div className="flex items-start gap-2 mb-2" data-id="element-49">
                <h3 className="text-base sm:text-lg font-bold text-brand-cream leading-tight" data-id="element-50">
                  {bonus.title}
                </h3>
              </div>
              <p className="text-sm text-gray-400 font-medium leading-snug" data-id="element-51">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}